import React from 'react'
import { Link } from 'react-router-dom'

export default function AdPromotionalBanner() {
  return (
    <>
    <Link to='/package-lead-form'> 
      {/* <div className="promotional-banner-fastival">A Rakhi Gift from PartyWitty – Exclusive <span className="promotional-banner-fastival-span">Table Booking </span> Offers for You & Your Sibling!</div> */}

      <div className="promotional-banner-fastival">Because vibes can’t wait — Book Now, Pay Later. <span className="promotional-banner-fastival-span">PARTY25</span> saves you upto 50%</div>
    </Link>
    </>
  )
}


  